import { Suspense, lazy } from "react";

import { Layout } from "../../features/layout";

const Content = lazy(() => import("./ContactContent"));

export function ContactPage() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <Content />
      </Suspense>
    </Layout>
  );
}
